import { createRoutine, promisifyRoutine } from 'redux-saga-routines'

// New comment on issue
// Routine for Form
export const submitCommentFormNewRoutine = createRoutine('SUBMIT_COMMENT_FORM_NEW')
export const submitCommentFinalFormNewHandler = promisifyRoutine(submitCommentFormNewRoutine)
